//@ts-check
import queryString from 'query-string';
import getSearchParams from './getSearchParams';
/**
 * @type {import("./types").extractSearchParamsType}
 */

export default function extractSearchParams(url) {
  return getSearchParams(queryString.extract(url));
}